module.exports = __webpack_public_path__ + "static/images/wait-get.ad31e8c.png";